const doc = [({"ko":({"adminButtonCompany":({"updateCreditCardFees":"결제 수수료 갱신", "updateSystemUsageFees":"시스템 사용료 업데이트"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;